import { Chip, Heading } from '@farol-ds/react'

import { ExploreWithJusButton } from '../explore-with-jus-button'
import styles from './legal-thesis-header.module.scss'

export interface LegalThesisHeaderProps {
  title: string
  clusterId: string
}

export function LegalThesisHeader(props: LegalThesisHeaderProps) {
  const { title, clusterId } = props

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Chip className={styles.chip}>Teses Jusbrasil</Chip>
        <Heading size="lg" className={styles.thesisTitle} asChild>
          <h1>{title}</h1>
        </Heading>
        <ExploreWithJusButton clusterId={clusterId} title={title} />
      </div>
    </div>
  )
}
